document.addEventListener("DOMContentLoaded", () => {
  // First script: Add the `open_in_new_window` custom attribute
  const links = document.querySelectorAll(".fit-content__links a");

  links.forEach(link => {
    link.setAttribute("open_in_new_window", "");
    link.setAttribute("rel", "noopener noreferrer");
  });

  // Second script: Add event listeners to handle `open_in_new_window`
  document.querySelectorAll("[open_in_new_window]").forEach(el => {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      try {
        const href = e.currentTarget.getAttribute("href");
        if (!href) {
          console.error("Error: The element does not have a valid 'href' attribute.");
          return;
        }
        const newWindow = window.open(href, '_blank');
        if (newWindow) {
          newWindow.focus();
        } else {
          console.error("Error: Unable to open a new window. Pop-up blocker might be enabled.");
          alert("Failed to open the link. Please check your browser's pop-up settings.");
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
      }
    });
  });
});


// focusMethod = function getFocus() {
//   document.querySelector(".search__input").focus();
// };

// // Search dropdown
// const openSearch = document.querySelector('.js-open-search');
// const closeSearch = document.querySelector('.js-close-search');
// const search = document.querySelector('.header__search');
// const searchInput = document.querySelector('.header__search .search__input');


// openSearch.addEventListener('click', () => {
//   console.log('asdlfkjhas');
//   if (search.classList.contains('is-visible')) {
//     search.classList.remove('is-visible');
//   } else {
//     search.classList.add('is-visible');
//     searchInput.setAttribute('tabindex', '0');
//     setTimeout(function() {
//       searchInput.focus();
//     }, 500)
//   }
// });

// closeSearch.addEventListener('click', () => {
//   search.classList.remove('is-visible');
// });